import React, {useState} from "react";
import DataTable from "react-data-table-component";
import { 
  Card, 
  Row,
  Col,
  CardBody,
  Button,
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
 } from "reactstrap";
 import { useNavigate } from "react-router-dom";
import helper from "../../components/helper/index"
import { FiChevronDown } from "react-icons/fi";
import { MyTaskData } from "../../components/Datas";
import { BiDotsVertical, BiErrorCircle, BiEdit,  } from "react-icons/bi";
// import "@styles/react/libs/tables/react-dataTable-component.scss";

const TaskTable = ({ data, action }) => {
  const [perPage, setPerPage] = useState(250);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  
  const navigate = useNavigate();
  const basicColumns = [
    {
      name: "Id",
      sortable: true,
      minWidth: "100px",
      selector: (rowData) =>
        rowData && rowData?.id ? rowData?.id : "-",
    },
    {
      name: "Task",
      sortable: true,
      minWidth: "150px",
      sortField: "vehicle_type",
      selector: (row) => helper.stringToJson(row?.vehicle_type?.vehicle_type).en,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row?.vehicle_type?.vehicle_type ? helper.stringToJson(row?.vehicle_type?.vehicle_type).en : "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Amount",
      minWidth: "120px",
      sortable: true,
      selector: row => row?.asset?.title,
      cell: row => {
        return (<div className="d-flex justify-content-left align-items-center">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row?.asset?.title ?? "-"}
            </span>
          </div>
        </div>)
      }
    },
    {
      name: "Date",
      minWidth: "120px",
      sortField: "Name",
      sortable: true,
      selector: (row) => row.date && row.date,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row?.date ?? "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Method",
      minWidth: "120px",
      sortField: "method",
      sortable: true,
      selector: (row) => row.method && row?.method,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row.method ?? "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Doctor",
      minWidth: "180px",
      sortField: "Name",
      sortable: true,
      selector: (row) => row?.doctor?.title,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row.doctor?.title ?? "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Patient",
      minWidth: "180px",
      sortField: "Name",
      sortable: true,
      selector: (row) => row?.user?.title,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {row?.user?.title ?? "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Created At",
      minWidth: "120px",
      sortField: "Name",
      sortable: true,
      selector: (row) => row?.created_at,
      cell: (row) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              {helper.removeTimeFromDate(row?.created_at) ?? "-"}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      sortable: true,
      minWidth: "130px",
      sortField: "Status",
      selector: (row) => row.status,
      cell: (item) => (
        <div className="d-flex justify-content-left align-items-center ">
          <div className="d-flex flex-column">
            <span className="fw-bold text-capitalize">
              <span
                className={`py-1 px-3 ${
                  item.status === 'Paid'
                    ? 'bg-subMain text-subMain'
                    : item.status === 'Pending'
                    ? 'bg-orange-500 text-orange-500'
                    : item.status === 'Cancel' && 'bg-red-600 text-red-600'
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.status}
              </span>
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Action",
      sortable: true,
      selector: (rowData, rowIndex) => {
        if (rowData) {
          return (
            <div className="flex justify-start items-center text-main py-2 px-4 rounded-lg">
  <div className="flex items-center">
    <UncontrolledDropdown>
      <DropdownToggle className='cursor-pointer' tag='span'>
        <BiDotsVertical size={15} />
      </DropdownToggle>
      <DropdownMenu className="fixed inset-auto z-10 p-3 bg-dry border">
        <>
          <DropdownItem key={"newToExisted"} onClick={() => "onOpenUpdateModal"(rowData)} className="w-full flex">
            <BiEdit size={18} className="" />
            <span className='ml-2'>Edit</span>
          </DropdownItem>
          <DropdownItem key={"Update"} onClick={() => "getTripDetail"(rowData)} className="w-full flex text-green-900">
            <BiErrorCircle size={18} className="" />
            <span className='ml-2'>View Detail</span>
          </DropdownItem>
          {/* <DropdownItem key={"Complete"} onClick={() => "getTripDetailPdf"(rowData)} className="w-full">
            <FiFileText size={18} className="text-green-600" />
            <span className='ml-2'>Get PDF</span>
          </DropdownItem> */}
        </>
      </DropdownMenu>
    </UncontrolledDropdown>
  </div>
</div>

          );
        }
      },
    },
  ];

  const onCurrPageChange = async (page) => {
    setCurrentPage(page);
    // await getFilteredData();
  };

  const handlePerRowsChange = async(newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const subHeaderComponentHandler = () => {

    return (
      <>
        <div className="flex justify-between items-center py-3">
          <div>
            <Button className="bg-teal-600 text-lime-50 p-2 rounded">
              Download CSV
            </Button>
          </div>
          <div className="flex items-center">
            <label className="mr-2" htmlFor="search-input">
              Search:
            </label>
            <input
              type="text"
              id="search-input"
              placeholder="Quick Search"
              value={searchValue}
              onChange={handleFilter}
              className="border border-teal-600 rounded p-2"
            />
          </div>
        </div>
      </>
    );
  };

  const handleFilter = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (value.length) {
      var filteredData = data.filter((item) => {
        const itemString = JSON.stringify(item).toLowerCase();
        return itemString.includes(value.toLowerCase());
      })
      setFilteredData(filteredData);
    }
  };

  const handleRowClicked = (row) => {
    navigate(`/all-cases/${3454535}`)
  }

  return (
    <Row className='match-height no-gap justify-content-center'>
        <Col className="pe-0 border-right-no-radius mobile-padding" md={'12'} sm={'12'} xs={'12'}>
          <Card className="no-shadow">
            <CardBody className="p-0">
              <div className="react-dataTable">
              <DataTable
                dense
                striped
                subHeader
                responsive
                fixedHeader
                pagination
                highlightOnHover
                // expandableRowsComponent={ExpandableRowComponentData}
                subHeaderComponent={subHeaderComponentHandler()}
                onRowClicked={handleRowClicked}
                fixedHeaderScrollHeight={'60vh'}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows}
                data={
                  searchValue
                    ? filteredData
                    : data
                }
                columns={basicColumns}
                onChangePage={onCurrPageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                sortIcon={<FiChevronDown size={10} />}
                className="react-dataTable cursor-pointer"
                paginationRowsPerPageOptions={[50, 100, 250, 500, 750, 1000]}
              />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
  );
};

export default TaskTable;
